import React from 'react';
import PropertyManagerDTO from 'features/contractualAccounts/dtos/PropertyManagerDTO';
import PageCard from 'features/shared/components/card/PageCard';
import InfoItem from 'features/shared/components/infoItem/InfoItem';
import ContactPerson from 'features/contractualAccounts/components/ContactPerson';
import { useTranslation } from 'react-i18next';

interface Props {
  manager: PropertyManagerDTO;
}

const PropertyManagerInfoCard = ({ manager }: Props) => {
  // translations
  const tLabels = useTranslation("contractualAccounts\\contractualAccounts").t;

  // sub-renders
  const renderPerson = () => {
    return <ContactPerson person={manager.contactPerson!} />;
  }

  // render
  return (
    <PageCard title={tLabels("propertyManagerInfoCard.cardTitle")} bodyClassName="pb-0">
      <div className="row no-gutters">
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("propertyManagerInfoCard.name")} value={manager.name} />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("propertyManagerInfoCard.address")} value={manager.address} />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("propertyManagerInfoCard.contactPerson")} value={renderPerson()}  /> 
        </div>
      </div>
    </PageCard>
  );
}

export default PropertyManagerInfoCard;
